import React, { useState } from 'react';
import Button from 'src/componentes/button';
import LucideIcon from 'src/componentes/lucide-icon';
import TruncatedText from 'src/componentes/truncated-text/TruncatedText';

import './InfoPanel.css';

const ACCENT_COLOR = '#1D7789';
const SOFT_BG = '#FAF5FF';
const SOFT_FG = '#6B21A8';

const CONTAINER_CLASS =
  'd-flex align-items-center justify-content-between p-2 my-2 rounded-lg';

function InfoPanel({
  children,
  className = '',
  showCloseButton = true,
  icon = 'information-outline',
  customMessage = false,
  onDismiss,
  maxLines = 2,
}) {
  const [visible, setVisible] = useState(true);

  if (!visible) {
    return null;
  }

  const accent = customMessage ? SOFT_FG : ACCENT_COLOR;
  const isStringContent = typeof children === 'string';

  const containerClass = customMessage
    ? `${CONTAINER_CLASS} ${className}`.trim()
    : `${CONTAINER_CLASS} bg-primary-light ${className}`.trim();

  const containerStyle = customMessage
    ? {
        backgroundColor: SOFT_BG,
        color: SOFT_FG,
        gap: '1rem',
      }
    : { color: ACCENT_COLOR, gap: '1rem' };

  return (
    <div className={containerClass} style={containerStyle}>
      <div
        className={`d-flex flex-grow-1 overflow-auto info-panel__content align-items-center`}
      >
        <LucideIcon
          icon={icon}
          className="mr-2 flex-shrink-0"
          color={accent}
        />
        <span className="me-3 flex-grow-1" style={{ minWidth: 0 }}>
          {isStringContent ? (
            <TruncatedText
              text={children}
              maxLines={maxLines}
              normalizeWhitespace={false}
              whiteSpace="pre-wrap"
              style={{
                fontSize: 'inherit',
                fontWeight: 'inherit',
                lineHeight: 'inherit',
                color: 'inherit',
              }}
              toggleClassName="truncated-text-toggle info-panel__toggle"
            />
          ) : (
            children
          )}
        </span>
      </div>
      {showCloseButton ? (
        <Button
          toolbar
          color="link"
          size="xs"
          icon={
            <LucideIcon icon="close" className="tw:size-4.5" color={accent} />
          }
          onClick={() => {
            setVisible(false);
            if (typeof onDismiss === 'function') {
              onDismiss();
            }
          }}
        />
      ) : null}
    </div>
  );
}

export default InfoPanel;
